/**
 * Privilege ID 命名规则
 *
 * 规则1：module.functional.object.operate
 * 规则2：module.functional.operate
 *
 * CRM 前端读取 Key 的格式除了“用户身份权限”，
 * 其他权限会去掉 crm 前缀，并统一使用驼峰命名
 *
 * @example
 *   CRM 线索管理->查看线索，crm.lead.private.view
 *              ->创建线索，crm.lead.private.create
 *
 *   CRM 产品->产品管理，crm.setting.product.manage
 *
 *   CRM 邮件->邮箱绑定，crm.setting.email.manage
 *               ->邮件模板，crm.setting.email.template
 *               ->邮件审批，crm.setting.email.review
 *
 *   DX 我的关注，dx.attention.read
 *      取消关注，dx.attention.cancel
 */

export default {
  // 用户身份权限
  crmAdmin: 'crm.admin', // CRM 超级管理员
  crmUser: 'crm.user', // 普通 CRM 用户
  dxAdmin: 'crm.dx.manage', // DX 管理员
  dxUser: 'crm.dx.user', // DX 普通用户
  mkAdmin: 'crm.mk.admin', // MK 管理员
  mkUser: 'crm.mk.user', // MK 普通用户
  enterpriseManage: 'enterprise.manage', // OS 管理员
  enterpriseBaseAccess: 'enterprise.base.access', // OS 普通用户
  aiUser: 'crm.ai.user', // 小满AI基础权限
  aiSetting: 'crm.ai.setting', // AI 自动化配置

  // Client 功能权限
  functionalMailV1: 'crm.functional.mail.v1',
  functionalBase: 'crm.functional.base', // 基础权限
  functionalDX: 'crm.functional.dx', // 小满发现
  functionalMK: 'crm.functional.mk', // 小满营销
  functionalOpportunity: 'crm.functional.opportunity', // 商机
  functionalOpportunityAdvancedSetting:
    'crm.functional.opportunity.advanced.setting', // 商机高级设置管理(商机设置)
  functionalOpportunityAdvancedStatistics:
    'crm.functional.opportunity.advanced.statistics', // 商机销售高级统计
  functionalOpportunitySalesFunnel: 'crm.functional.opportunity.sales.funnel', // 商机销售漏斗
  functionalOpportunitySalesForecast:
    'crm.functional.opportunity.sales.forecast', // 商机销售预测
  functionalLead: 'crm.functional.lead', // 线索列表
  functionalLeadPool: 'crm.functional.lead.pool', // 线索公海
  functionalBillQuote: 'crm.functional.bill.quote', // 报价工具
  functionalAccountAdd: 'crm.functional.account.add', // 添加小满用户账号 *
  functionalAI: 'crm.functional.ai', // AI模块权限
  functionalAIClassifyOpportunity: 'crm.functional.ai.classify.opportunity', // AI模块 => 商机自动化
  functionalAIClassifyOpportunitySettingEdit:
    'crm.functional.ai.classify.opportunity.setting.edit', // 商机自动化编辑
  functionalAIClassifyCustomer: 'crm.functional.ai.classify.customer', // AI模块 => 客户自动化
  functionalAIDashboard: 'crm.functional.ai.dashboard', // AI仪表盘
  functionalAIRecommend: 'crm.functional.ai.recommend', // AI 推荐 / 开发信
  functionalAIMovePool: 'crm.functional.ai.move.pool', // AI客户即将移入公海
  functionalAICiq: 'crm.functional.ai.ciq', // AI客户海关数据更新
  functionalCiq: 'crm.functional.ciq', // 海关数据 3.0
  functionalAIFollowCustomer: 'crm.functional.ai.follow.customer', // AI跟进客户
  functionalAIDevelopLead: 'crm.functional.ai.develop.lead', // AI 开发新线索
  functionalAIFollowLead: 'crm.functional.ai.follow.lead', // AI 跟进线索
  functionalAIClassifyEmail: 'crm.functional.ai.classify.email', // AI邮件自动分类
  functionalAIArchiveRecommend: 'crm.functional.ai.recommend.after.archive', // 客户建党后 ai 推荐
  functionalAIEmailSentRecommend: 'crm.functional.ai.recommend.after.send', // 邮件发送完成后 ai 推荐
  functionalBoss: 'crm.functional.boss', // 销售端
  functionalPerformanceOrderCustomField:
    'crm.functional.performance.order.custom.field', // 业绩管理设置--添加统计口径
  functionalCompanyPool: 'crm.functional.company.pool', // 公海客户列表
  functionalCompanyPoolSetting: 'crm.functional.company.pool.setting', // 客户公海分组
  functionalCompanyPoolAutoRules: 'crm.functional.company.pool.auto.rules', // 客户自动移入公海规则
  functionalOrder: 'crm.functional.order', // 订单
  functionalQuotation: 'crm.functional.quotation', // 报价单
  functionalReviewBase: 'crm.functional.review.base', // 审批管理
  functionalPaypal: 'crm.functional.paypal', // paypay
  functionalStructure: 'crm.functional.structure', // 销售管理的组织架构
  functionalWorkbench: 'crm.functional.workbench', // 工作台
  functionalStatistic: 'crm.functional.statistic', // 统计分析
  mailView: 'crm.mail.view', // 邮件模块权限
  functionalCashCollection: 'crm.functional.cashCollection', // 回款单
  functionalLogistics: 'crm.functional.transport', // 物流运输模块

  // 角色、用户操作权限
  settingAccountInfo: 'crm.setting.account.info', // 账号信息
  settingInfoManage: 'crm.setting.info.manage', // 企业资料管理员
  settingEdmSetting: 'crm.setting.edm', // 营销设置
  settingContactsManage: 'crm.setting.contacts.manage', // 通讯录管理
  settingCustomerManage: 'crm.setting.customer.manage', // 客户设置
  settingCustomerPool: 'crm.setting.customer.pool', // 公海分组管理
  settingDiskManage: 'crm.setting.disk.manage', // 云盘
  settingEmailManage: 'crm.setting.email.manage', // 邮箱管理－邮箱绑定
  settingEmailReview: 'crm.setting.email.review', // 邮箱管理-邮件审批
  settingEmailReviewSpecify: 'crm.setting.email.review.specify', // 邮箱审批人
  settingEmailTemplate: 'crm.setting.email.template', // 邮箱管理－邮件模版
  settingExchangeManage: 'crm.setting.exchange.manage', // 汇率设置
  settingCustomerExport: 'crm.setting.customer.export', // 客户管理－客户导出
  settingOrderManage: 'crm.setting.order.manage', // 订单设置
  settingOrderExport: 'crm.setting.order.export', // 订单设置-下属订单－订单批量导出
  settingOrderTemplate: 'crm.setting.order.template', // 订单设置－订单导出模版设置
  settingOrganizationManage: 'crm.setting.organization.manage', // 组织架构管理员
  settingPrivilegeManage: 'crm.setting.privilege.manage', // 权限管理
  settingProductManage: 'crm.setting.product.manage', // 产品管理
  settingQuotationManage: 'crm.setting.quotation.manage', // 报价单设置
  settingQuotationExport: 'crm.setting.quotation.export', // 报价单设置－下属报价单－报价单批量导出
  settingQuotationTemplate: 'crm.setting.quotation.template', // 报价单设置－报价单导出模版设置
  settingRecycleManage: 'crm.setting.recycle.manage', // 回收箱
  settingAccountRelation: 'crm.setting.account.relation', // 设置－账号关联
  settingReviewManage: 'crm.setting.review.manage', // 审批管理
  settingStatisticAnalyse: 'crm.statistics.view', // 统计分析
  settingStatisticManage: 'crm.setting.statistic.manage', // 统计分析管理
  settingTemplateManage: 'crm.setting.template.manage', // 模板管理
  settingOriginManage: 'crm.setting.origin.manage', // 来源设置
  settingModuleManage: 'crm.setting.module.manage', // 模块开关
  settingFieldsManage: 'crm.setting.fields.manage', // 字段设置
  settingOpportunityManage: 'crm.setting.opportunity.manage', // 商机设置
  settingPaypalManage: 'crm.setting.paypal.manage', // paypal收款设置
  settingPerformanceManage: 'crm.setting.performance.manage', // 业绩管理
  settingUserManage: 'crm.setting.user.manage', // 成员管理

  labMailRead: 'crm.lab.mail.read', // 智能邮件内容分析
  labMailSentiment: 'crm.lab.mail.sentiment', // 智能邮件情绪分析

  leadPrivateView: 'crm.lead.private.view', // 查看线索
  leadPrivateCreate: 'crm.lead.private.create', // 创建线索
  leadPrivateRemove: 'crm.lead.private.remove', // 删除线索
  leadPrivateEdit: 'crm.lead.private.edit', // 编辑线索
  leadPrivateTransfer: 'crm.lead.private.transfer', // 转移线索
  leadPrivateReport: 'crm.lead.private.report', // 线索报表
  leadPrivateMove: 'crm.lead.move.pool', // 线索移入公海
  leadPoolView: 'crm.lead.pool.view', // 查看公海线索
  leadPoolCreate: 'crm.lead.pool.create', // 创建公海线索
  leadPoolRemove: 'crm.lead.pool.remove', // 删除公海线索
  leadPoolEdit: 'crm.lead.pool.edit', // 编辑公海线索
  leadPoolTransfer: 'crm.lead.pool.transfer', // 转移公海线索

  opportunityTransfer: 'crm.opportunity.transfer', // 转移商机
  opportunityMemberManage: 'crm.opportunity.member.manage', // 商机联系人管理
  opportunityCreate: 'crm.opportunity.create', // 创建商机
  opportunityEdit: 'crm.opportunity.edit', // 编辑商机
  opportunityRemove: 'crm.opportunity.remove', // 删除商机
  opportunityTrailCreate: 'crm.opportunity.trail.create', // 创建商机动态
  opportunityView: 'crm.opportunity.view', // 商机模块可见

  edmView: 'crm.edm.view', // 查看营销邮件
  edmAuto: 'crm.edm.auto', // 自动化邮件营销
  edmContactsExport: 'crm.edm.contacts.export', // 营销联系人导出

  // 客户
  companyPrivateView: 'crm.company.private.view', // 查看客户
  companyPrivateCreate: 'crm.company.private.create', // 创建客户
  companyPrivateRemove: 'crm.company.private.remove', // 删除客户
  companyPrivateEdit: 'crm.company.private.edit', // 编辑客户
  companyPrivateTransfer: 'crm.company.private.transfer', // 转移客户
  companyPrivateReport: 'crm.company.private.report', // 客户报表
  companyPrivateAssign: 'crm.company.private.assign', // 分配客户
  companyPrivateShare: 'crm.company.private.share', // 分享客户
  companyPrivateRelease: 'crm.company.private.release', // 客户取消跟进
  companyPrivateMovePool: 'crm.company.private.move.pool', // 客户移入公海
  companyPrivateMerge: 'crm.company.private.merge', // 私海客户合并

  companyPoolView: 'crm.company.pool.view', // 公海客户查看
  companyPoolAssign: 'crm.company.pool.assign', // 公海客户分配
  companyPoolCreate: 'crm.company.pool.create', // 公海客户创建
  companyPoolRemove: 'crm.company.pool.remove', // 公海客户删除
  companyPoolEdit: 'crm.company.pool.edit', // 公海客户编辑
  companyPoolHold: 'crm.company.pool.hold', // 客户移入私海
  companyPoolSetting: 'crm.company.pool.setting', // 客户公海分组设置
  companyPoolCustomerView: 'crm.company.customer.view', // 公海联系人查看

  // 报价单
  quotationView: 'crm.quotation.view', // 产看报价单
  quotationCreate: 'crm.quotation.create', // 添加报价单
  quotationEdit: 'crm.quotation.edit', // 编辑报价单
  quotationRemove: 'crm.quotation.remove', // 删除报价单

  // 订单
  orderView: 'crm.order.view', // 产看订单
  orderCreate: 'crm.order.create', // 添加订单
  orderEdit: 'crm.order.edit', // 编辑订单
  orderRemove: 'crm.order.remove', // 删除订单

  // 产品
  productView: 'crm.product.view', // 产品查看

  // 邮件
  mailHardRemove: 'crm.mail.hard.remove', // 邮件彻底删除

  // 部门管理员和超管的虚拟权限
  callSubordinate: 'crm.call.subordinate', // 下属通话记录

  performanceView: 'crm.performance.view', // 业绩查看
  performanceCreate: 'crm.performance.create', // 业绩创建、编辑
  performanceExport: 'crm.performance.export', // 业绩导出
  performanceSetting: 'crm.performance.setting', // 业绩设置

  // 回款单
  cashCollectionView: 'crm.cashCollection.view', // 回款单查看
  cashCollectionCreate: 'crm.cashCollection.create', // 回款单创建、编辑
  cashCollectionRelate: 'crm.cashCollection.relate', // 回款单关联
  cashCollectionRemove: 'crm.cashCollection.remove', // 回款单删除
  cashCollectionSetting: 'crm.cashCollection.setting', // 回款单设置

  // DX相关
  dxProductSearch: 'crm.functional.dx.product.search', // 产品搜索
  dxCompanySearch: 'crm.functional.dx.company.search', // 公司搜索
  dxMining: 'crm.functional.dx.mining', // 客户发掘
  dxFollow: 'crm.functional.dx.follow', // 客户关注
  dxAssistant: 'crm.functional.dx.assistant', // 小满助手
  dxRecommended: 'crm.functional.dx.recommended', // 定制推荐
  dxSubscription: 'crm.functional.dx.subscription', // 订阅
  dxCiq: 'crm.functional.dx.ciq', // 海关数据

  // MK相关
  mkBase: 'crm.functional.mk.base',
  mkTool: 'crm.functional.mk.tool',

  // 工作流
  workflow: 'crm.setting.workflow.manage',

  // 审批流
  approvalFlow: 'crm.setting.approvalflow.manage',

  logisticsView: 'crm.transport.view', // 物流运输查看权限
};
